<template>
  <label for="amortization-rate">{{$store.getters.translations.repayment_rate}}</label>
  <div class="select-wrapper">
    <select @change="emitChange($event)" name="amortization-rate" id="amortization-rate">
      <option v-for="value in rates" :key="value" :value="value" :selected="amortizationRate === value">
        {{formatValue(value)}} %
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    rates:Array,
    amortizationRate:Number
  },
  emits:[
      'change-amortization-rate'
  ],
  name: "amortization-rate",
  data(){
    return {
    };
  },
  methods: {
    formatValue(value) {
      return value.toFixed(1);
    },
    emitChange(event){
      this.$emit("change-amortization-rate", event.target.value);
    }
  },
  mounted() {

  }
};
</script>
